<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenterb"><a id="ch00_fm06"></a><a id="page_vii">“… On the trees no leaf is seen<br/>Nor are the meadows growing green,<br/>Birds build no nest, no song is sung,<br/>And hapless beasts shall bear no young,<br/>So is it while the sinful king<br/>Shall evil on his people bring.<br/>For Jesus Christ does punish well<br/>The land wherein the wicked dwell.”</a></p><a id="page_vii">
<p class="textleft"><span class="small">SONE DE NANSAI</span>, 11.4848-56</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?d8777e7e